var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"title-part"},[_c('div',{staticClass:"module-title"},[_vm._v("流量趋势")])]),_c('div',{staticClass:"line-chart",attrs:{"id":"line-chart"}})])
}]

export { render, staticRenderFns }